"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ComputedRenderer_1 = __importDefault(require("./ComputedRenderer"));
/**
 * This is a small component used to short circuit form controls which do not have a conditional map.
 * The reason we can't just put this in the actual Conditional component is that the conditional evaluation
 * requires looking up the current form state which is expensive, and that hook(like all hooks) can't be made conditional.
 * @param conditionalMap The mapping used to determine the visibility of the current form object
 */
const ComputedOptimizer = props => {
    const { controlPath, controlDefinition, children } = props;
    if (!controlDefinition.computedMap) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    else {
        return (react_1.default.createElement(ComputedRenderer_1.default, { controlPath: controlPath, controlDefinition: controlDefinition }, children));
    }
};
exports.default = ComputedOptimizer;
